import { render, staticRenderFns } from "./customreports.vue?vue&type=template&id=7d06e270&scoped=true"
import script from "./customreports.vue?vue&type=script&lang=js"
export * from "./customreports.vue?vue&type=script&lang=js"
import style0 from "./customreports.vue?vue&type=style&index=0&id=7d06e270&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d06e270",
  null
  
)

export default component.exports